<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	width="100%"
	height="100%"
	viewBox="0 0 915 1109"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={classes('', additionalClass)}
>
	<g style="mix-blend-mode:multiply" filter="url(#filter0_f_8334_14204)">
		<path
			d="M205.781 814.187C352.257 974.17 582.926 994.669 720.996 859.974C859.065 725.278 965.667 538.228 769.481 284.036C623.005 124.053 392.536 83.5848 347.808 380.332C311.018 624.417 59.3056 654.205 205.781 814.187Z"
			fill="url(#paint0_linear_8334_14204)"
		/>
	</g>
	<defs>
		<filter
			id="filter0_f_8334_14204"
			x="0.392578"
			y="0.264648"
			width="1036.56"
			height="1108.71"
			filterUnits="userSpaceOnUse"
			color-interpolation-filters="sRGB"
		>
			<feFlood flood-opacity="0" result="BackgroundImageFix" />
			<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
			<feGaussianBlur stdDeviation="80" result="effect1_foregroundBlur_8334_14204" />
		</filter>
		<linearGradient
			id="paint0_linear_8334_14204"
			x1="699.993"
			y1="245.979"
			x2="218.008"
			y2="847.325"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#F7FBA5" />
			<stop offset="0.541667" stop-color="#D09CC7" />
			<stop offset="1" stop-color="#8F00FF" />
		</linearGradient>
	</defs>
</svg>
